// frontend/src/pages/DiscordClaimResult.js
import { Link, useSearchParams } from "react-router-dom";

import PageContainer from "../components/layout/PageContainer";
import GlassPanel from "../components/layout/GlassPanel";

function getMessage(success, reason) {
  if (success === "1") {
    return {
      icon: "✅",
      title: "Discord Role Claimed!",
      text: "Your Discord supporter role has been assigned successfully.",
    };
  }

  if (reason === "already_claimed") {
    return {
      icon: "⚠️",
      title: "Role Already Claimed",
      text: "This order has already been used to claim a Discord role.",
    };
  }

  if (reason === "order_not_completed") {
    return {
      icon: "⚠️",
      title: "Order Not Completed",
      text: "This order is not marked as completed yet.",
    };
  }

  if (reason === "invalid_claim_token") {
    return {
      icon: "❌",
      title: "Invalid Claim Link",
      text: "This claim link is invalid or expired.",
    };
  }

  if (reason === "missing_role_id") {
    return {
      icon: "❌",
      title: "Missing Discord Role",
      text: "The Discord role is not configured correctly.",
    };
  }

  return {
    icon: "❌",
    title: "Claim Failed",
    text: "Something went wrong while claiming your Discord role. Please join Discord and contact support.",
  };
}

export default function DiscordClaimResult() {
  const [searchParams] = useSearchParams();

  const success = searchParams.get("success") || "0";

  const reason = searchParams.get("reason") || "";

  const message = getMessage(success, reason);

  return (
    <PageContainer>
      <div
        style={{
          width: "100%",
          maxWidth: 760,
        }}
      >
        <GlassPanel>
          <div
            style={{
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 72,
                marginBottom: 20,
              }}
            >
              {message.icon}
            </div>

            <h1
              style={{
                fontSize: 48,
                marginBottom: 20,
              }}
            >
              {message.title}
            </h1>

            <p
              style={{
                opacity: 0.85,
                lineHeight: 1.8,
                fontSize: 20,
              }}
            >
              {message.text}
            </p>

            <div
              style={{
                marginTop: 36,
              }}
            >
              <Link
                to="/"
                style={{
                  padding: "14px 24px",
                  borderRadius: 14,
                  background: "rgba(255,255,255,0.08)",
                  color: "#fff",
                  textDecoration: "none",
                  fontWeight: 800,
                }}
              >
                Back to Home
              </Link>
            </div>
          </div>
        </GlassPanel>
      </div>
    </PageContainer>
  );
}
